import { buildQueryParams, requestBuilder } from '../../http/RequestBuilder';
import { type LinkedTransactionsResponse } from './useGetHolisticTransactions';

interface SearchTransactionsParams {
    searchTerm: string;
    limit?: number;
    accountId?: string;
    startDate?: string;
    endDate?: string;
}

export const useSearchTransactions = requestBuilder.query<
    LinkedTransactionsResponse,
    SearchTransactionsParams
>({
    endpoint: (params) => {
        const queryParams: Record<string, string> = {
            q: params.searchTerm,
        };

        if (params.limit != null) {
            queryParams.limit = params.limit.toString();
        }
        if (params.accountId != null && params.accountId !== '') {
            queryParams.accountId = params.accountId;
        }
        if (params.startDate != null && params.startDate !== '') {
            queryParams.startDate = params.startDate;
        }
        if (params.endDate != null && params.endDate !== '') {
            queryParams.endDate = params.endDate;
        }

        return `/api/holistic/transactions/search${buildQueryParams(queryParams)}`;
    },
    queryKey: (params) =>
        `searchTransactions/${params.searchTerm}/${params.limit ?? 'default'}/${params.accountId ?? 'all'}/${params.startDate ?? 'none'}/${params.endDate ?? 'none'}`,
});
